t = require('views/internal/teacup-with-helpers')('date_picker')

module.exports = t.renderable ({ upsellEnabled, canChangePowerUps, canEnableAdditionalPowerUps }) ->
  t.div '.datepicker-select.u-clearfix', ->

    t.div '.datepicker-select-date', ->
      t.label '.datepicker-select-label', ->
        t.format 'date'
        t.input '.datepicker-select-input.js-dpicker-date-input.js-autofocus', { type: 'text', placeholder: t.l('enter-date'), tabindex: 101 }

    t.div '.datepicker-select-time', ->
      t.label '.datepicker-select-label', ->
        t.format 'time'
        t.input '.datepicker-select-input.js-dpicker-time-input', { type: 'text', placeholder: t.l('enter-time'), tabindex: 102 }

  t.div '.pickers.js-dpicker-cal'

  t.div '.datepicker-confirm-btns', ->
    t.input '.primary.wide.confirm',
      type: 'submit'
      value: t.l('save')
      tabindex: 103

    t.button '.negate.remove-date.js-remove-date', { type: 'button', tabindex: 104 }, ->
      t.format 'remove'

  t.div '.js-enable-cal.hide', ->

    t.hr()

    if canEnableAdditionalPowerUps
      t.p ->
        t.a '.quiet-button.mod-with-image.js-enable-calendar-powerup', { href: '#' }, ->
          t.icon 'power-up', 'enable-the-calendar-power-up', { class: 'quiet-button-icon' }

      t.p '.u-bottom.quiet', ->
        t.format 'you-ll-get-a-calendar-view-of-your-cards-and-an-ical-feed-woo'
    else
      if upsellEnabled
        t.p '.u-bottom.quiet', ->
          t.format 'upgrade-to-business-class-to-enable-the-calendar-power-up'
          t.text ' '
          t.format 'you-ll-get-a-calendar-view-of-your-cards-and-an-ical-feed-woo'

  t.div '.js-cal-enabled.hide', ->

    t.hr()

    t.p '.helper', ->
      if canChangePowerUps
        t.format 'click-the-calendar-button-in-the-board-header-to-open-the-calendar-to-change-calendar-settings-click-power-ups-in-the-board-menu'
      else
        t.format 'click-the-calendar-button-in-the-board-header-to-open-the-calendar'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/date_picker.coffee